import { render, staticRenderFns } from "./pear.vue?vue&type=template&id=7cedc3ac&"
import script from "./pear.vue?vue&type=script&lang=js&"
export * from "./pear.vue?vue&type=script&lang=js&"
import style0 from "./pear.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports